var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7443 6.37752L9.9661 0.599228C9.80116 0.434286 9.58132 0.34375 9.34692 0.34375C9.11225 0.34375 8.89255 0.434416 8.7276 0.599228L8.20299 1.12397C8.03818 1.28865 7.94738 1.50862 7.94738 1.74315C7.94738 1.97756 8.03818 2.20494 8.20299 2.36962L11.5739 5.74793H0.864383C0.381525 5.74793 0 6.12595 0 6.60893V7.35078C0 7.83377 0.381525 8.2499 0.864383 8.2499H11.6121L8.20312 11.6471C8.03831 11.812 7.94751 12.026 7.94751 12.2605C7.94751 12.4948 8.03831 12.7119 8.20312 12.8767L8.72773 13.3998C8.89268 13.5647 9.11238 13.6546 9.34705 13.6546C9.58145 13.6546 9.80129 13.5635 9.96623 13.3986L15.7444 7.62044C15.9097 7.45498 16.0007 7.2341 16 6.99931C16.0005 6.76373 15.9097 6.54272 15.7443 6.37752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.785f069a53caff603fc40eead102c94c.svg";
export { ForwardRef as ReactComponent };